import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme) => ({
    boxCenter: {
        display: "flex",
        "justify-content": "center",
        alignItems: "center",
        width: "100%",
    },
    box: {
        display: "block",
        width: "1350px",
    },
    boxPrancheta: {
        height: "400px",
        backgroundColor: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
    },
    dashboard_header: {
        display: "flex",
        width: "100%",
        height: "70px",
        justifyContent: "center",
        backgroundColor: "#D6EAF8",
        gap: "10px",
        //        border: '1px solid red',
    },
    span_name: {
        fontSize: "110%",
        color: "white",
        fontWeight: "bold",
    },
    span_value: {
        fontSize: "110%",
        color: "green",
        fontWeight: "bold",
        marginLeft: "10px",
    },

    center_data: {
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        alignItems: "baseline",
        //          border: '1px solid blue',
        flexDirection: "row",
    },
    dashboard_header_status: {
        display: "flex",
        //        'max-width': '600px',
        justifyContent: "center",
        alignContent: "center",
        flexDirection: "row",
        alignItems: "center",
    },
    entrada_de_dados: {
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        flexDirection: "row",
        alignItems: "center",
        height: "100px",
    },
    campos: {
        padding: "20px",
    },

    dashboard_content: {
        display: "flex",
        flexDirection: "row",
        //    border: '1px solid green',
        justifyContent: "space-evenly",
        alignItems: "center",
    },
    boxDataGrid: {
        "& .header_grid": {
            backgroundColor: "#2471A3",
            color: "white",
        },
        width: "100%",
        height: "400px",
        backgroundColor: "white",
    },
    side_content: {
        display: "grid",
        overflow: "auto",
    },
    containerName: {
        width: "200px",
    },

    nome: {
        width: "400px",
    },
    radio_group_custom: {
        fontSize: "15px",
        label: {
            fontSize: "0.8em",
        },
        MuiFormControlLabel: {
            label: {
                fontSize: "0.8em",
            },
        },
        checkboxLabel: {
            fontSize: "15px",
        },
    },
    header_grid: {
        backgroundColor: "black",
        color: "white",
    },
    input_data: {
        display: "flex",
        flexDirection: "column",
    },
    fab: {
        display: "inline",
        position: "absolute",
        bottom: "0px",
        right: "0",
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(0),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));
